<template>
  <div v-loading="loading">
    <el-alert
      v-if="stockValue && !stockValue.is_correct && stockValue.is_date_correct"
      title="Készletérték nem pontos"
      type="warning"
      show-icon
      :closable="false"
      style="margin-bottom: 20px"
    >
      Amennyiben van olyan esemény (bevételezés, leltártöbblet, képviselői termékleadás, vevői visszáru) a megadott dátumnál korábban, amelynél nincs véglegesítve a beszerzési ár, abban az esetben a termék akkori beszerzési árával számolódik a készlet egy bizonyos része.
    </el-alert>
    <el-alert
      v-if="stockValue && stockValue.is_correct && stockValue.is_date_correct"
      title="Készletérték pontos"
      type="success"
      show-icon
      :closable="false"
      style="margin-bottom: 20px"
    >
      Minden szükséges eseménynél (bevételezés, leltártöbblet, képviselői termékleadás, vevői visszáru) véglegesítve vannak a beszerzési árak.
    </el-alert>
    <el-alert
      v-if="stockValue && !stockValue.is_date_correct"
      title="Hibás adat"
      type="error"
      show-icon
      :closable="false"
      style="margin-bottom: 20px"
    >
      Az előző napi készletértéknél újabb nem kérdezhető le.
    </el-alert>
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stockValue && stockValue.stock_values"
      style="width: 100%"
      row-key="id"
      border
      @sort-change="handleSortChange"
      show-summary
      :summary-method="getSum"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
    </el-table>
  </div>
</template>

<script>
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      stockValue() {
        return this.$store.getters['stockValue/stockValue'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['stockValue/tableConfig']));
      },
      loading() {
        return this.$store.getters['stockValue/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('stockValue/setFilterString', '');
      this.$store.commit('stockValue/setSorting', this.currentSort);
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockValue/setSorting', { prop, order });
          this.$store.dispatch('stockValue/fetchAll');
        }
      },
      getSum(params) {
        let result = [];
        let sum = 0;
        let stockSum = 0;
        params.data.forEach(stockValue => {
          sum += stockValue.net_purchase_price;
          stockSum += stockValue.full_count;
        });
        result = params.columns.map((column, index) => {
          if (index === 0) {
            return 'Össz.:';
          }
          if(column.property === 'value') {
            return this.$options.filters.currency(sum.toFixed(2));
          }
          if(column.property === 'count') {
            return stockSum + ' db';
          }
          return '';
        });
        return result;
      },
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
